exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.box[data-v-7e8a1bb4]{\n    margin-right: 25%;\n    margin-left: 25%;\n    margin-top: 55px;\n    border: 3px solid #35495E;\n    border-radius: 20px;\n}\n.field[data-v-7e8a1bb4]{\n    padding:10px;\n    text-align:center;\n}\n.textlabel[data-v-7e8a1bb4]{\n    white-space:nowrap;\n    color:#35495E;\n}\n.textfield[data-v-7e8a1bb4]{\n    width:100%;\n}\n.title[data-v-7e8a1bb4]{\n    font-size:30px;\n    font-weight:bold;\n    color:#35495E;\n}\n.smalltext[data-v-7e8a1bb4]{\n    font-size: 12px;\n\tcolor: #888888;\n}\nbutton.link[data-v-7e8a1bb4] {\n    background:none;\n    border:none;\n    color:#0066dd;\n    text-decoration: underline;\n}\ntable[data-v-7e8a1bb4] {\n    table-layout:auto;\n    margin:auto;\n    width:75%;\n    border: none;\n}\ntd[data-v-7e8a1bb4] {\n    border: none;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-7e8a1bb4","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/file/Forgot_Password.vue
// module id = 515
// module chunks = 0